import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'


import vuetify from './plugins/vuetify';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';
import { loadFonts } from './plugins/webfontloader'

import ActionCard from './components/App/UI/ActionCard.vue';
import DenseActionCard from './components/App/UI/DenseActionCard.vue';
import SportipsButton from './components/App/UI/Buttons/DefaultButton.vue';



loadFonts()

import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_BASE;
const headers_cache = {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
};
axios.defaults.headers = headers_cache;


import moment from 'moment';
moment.locale('fr');



/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* import font awesome icon component */
import {
    faAngleRight,
    faAngleLeft,
    faArrowRight,
    faArrowLeft,
    faCartShopping
} from "@fortawesome/free-solid-svg-icons";
import { faCalendar, } from "@fortawesome/free-regular-svg-icons";

library.add(
    faAngleLeft,
    faAngleRight,
    faCalendar,
    faArrowLeft,
    faArrowRight,
    faCartShopping
);

import VueCookies from "vue-cookies";

import { formRules } from './assets/js/formRules.js';
import { itemsSelect } from './assets/js/itemsSelect.js';
import { coureurCategories } from './assets/js/coureurCategories.js';

import JsonViewer from 'vue-json-viewer';

import VueGtag from "vue-gtag";


const configVueGtag = {
    config: { id: "UA-90740854-1" },
    pageTrackerTemplate(to) {
        return {
            page_path: to.fullPath,
            page_title: "Inscription - " + to.fullPath.replace("/", ""),
        };
    },
};

import 'flag-icons/css/flag-icons.min.css';
import 'v-phone-input/dist/v-phone-input.css';
import { createVPhoneInput } from 'v-phone-input';
import { VAutocomplete } from 'vuetify/components';

const vPhoneInput = createVPhoneInput({
    displayFormat: 'international',
    enableSearchingCountry: true
});









const pinia = createPinia();

const app = createApp(App).use(router).use(pinia).use(VueTelInputVuetify, {
    vuetify,
}).use(vuetify).use(VueCookies, { expire: "7d" }).use(JsonViewer).use(VueGtag, configVueGtag, router).use(vPhoneInput);
app.component("FontAwesomeIcon", FontAwesomeIcon);
app.component("ActionCard", ActionCard);
app.component('VAutocomplete', VAutocomplete);
app.component("DenseActionCard", DenseActionCard);
app.component("SportipsButton", SportipsButton);
app.config.globalProperties.axios = axios;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$formRules = formRules;
app.config.globalProperties.$itemsSelect = itemsSelect;
app.config.globalProperties.$coureurCategories = coureurCategories;

router.isReady().then(() => {
    app.mount('#app');
});
